var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guest-layout"},[_c('GuestHeader'),_c('router-view',{staticClass:"guest-layout__router-view"}),_c('GuestFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }